import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "@/lib/i18n";
import { Button } from "@/components/ui/button";
import { ArrowLeft, AlertCircle } from "lucide-react";

const COPY = {
  es: {
    title: "Pago cancelado.",
    copy: "No se ha realizado ningún cargo. Tu aplicación está guardada pero no será procesada hasta que completes el pago.",
    retry: "REINTENTAR APLICACIÓN",
    backHome: "VOLVER AL INICIO",
    note: "El compromiso financiero filtra a los curiosos. Si quieres entrar en MTK, necesitas estar dispuesto.",
  },
  en: {
    title: "Payment cancelled.",
    copy: "No charge was made. Your application is saved but won't be processed until you complete payment.",
    retry: "RETRY APPLICATION",
    backHome: "BACK TO HOME",
    note: "The financial commitment filters tire-kickers. If you want in MTK, you need to be willing.",
  },
};

export default function ApplyCancelled() {
  const { lang } = useLang();
  const c = COPY[lang] || COPY.es;
  return (
    <div className="min-h-screen bg-mtk-bg text-white flex flex-col" data-testid="apply-cancelled-page">
      <header className="px-6 md:px-12 py-6 flex items-center justify-between border-b border-mtk-border">
        <Link to="/" className="flex items-center gap-2 text-zinc-400 hover:text-mtk-gold transition-colors">
          <ArrowLeft className="w-4 h-4" />
          <span className="font-mono-mtk text-[10px] tracking-[0.3em] uppercase">HOME</span>
        </Link>
        <div className="flex items-baseline gap-2">
          <span className="font-heading text-lg font-black tracking-[0.2em] text-white">MTK</span>
          <span className="font-mono-mtk text-[10px] tracking-[0.3em] text-mtk-gold uppercase">SYSTEM</span>
        </div>
        <div className="w-16" />
      </header>

      <main className="flex-1 flex items-center justify-center px-6 py-16">
        <div className="w-full max-w-xl">
          <div className="border border-mtk-border bg-mtk-surface p-10 md:p-14 text-center">
            <div className="inline-flex items-center justify-center w-16 h-16 border border-mtk-border mb-6">
              <AlertCircle className="w-7 h-7 text-zinc-400" strokeWidth={1.5} />
            </div>
            <h1 className="font-heading text-3xl md:text-4xl font-black uppercase tracking-tight text-white">
              {c.title}
            </h1>
            <p className="mt-5 text-zinc-300 max-w-md mx-auto">{c.copy}</p>
            <div className="mt-8 border-l-2 border-mtk-gold pl-5 text-left max-w-sm mx-auto">
              <p className="font-heading text-base text-mtk-gold/90 italic">{c.note}</p>
            </div>
            <div className="mt-10 flex flex-col sm:flex-row gap-3 justify-center">
              <a href="/#apply">
                <Button
                  data-testid="cancelled-retry-btn"
                  className="rounded-none bg-mtk-gold text-mtk-bg hover:bg-mtk-gold-light font-bold uppercase tracking-[0.25em] text-xs h-12 px-6"
                >
                  {c.retry}
                </Button>
              </a>
              <Link to="/">
                <Button
                  variant="outline"
                  className="rounded-none border-mtk-border bg-transparent text-white hover:bg-white/5 font-bold uppercase tracking-[0.25em] text-xs h-12 px-6"
                >
                  {c.backHome}
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
